const itemTypes = {
  CARD: 'card',
}
export default itemTypes
